export default __webpack_public_path__ + "static/media/Screenshot (97).cac93ded.png";